<template>
  <section
    class="pa-6"
    aria-labelledby="profile-install-title"
  >
    <h2
      id="profile-install-title"
      class="text-h6 mb-2"
    >
      Self Biography app
    </h2>
    <p>Add Self Biography to your home screen or desktop.</p>
    <v-btn
      color="primary"
      outlined
      @click="openInstallDialog"
    >
      <v-icon left>
        {{ mdiDownload }}
      </v-icon>
      Install / Instructions
    </v-btn>
  </section>
</template>

<script>
import { mdiDownload } from '@mdi/js'
import { openInstallDialog } from '@/services/pwa'

export default {
  data: () => ({ mdiDownload }),
  methods: { openInstallDialog },
}
</script>
